/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import CookiesProvider from '../providers/Cookies';

const CONSENT_LEVEL = {
  ESSENTIAL: 'Essential',
  FUNCTIONAL: 'Functional',
  MARKETING: 'Marketing',
  PERFORMANCE: 'Performance',
};

const getCookieSetter = (consentLevel) => (key, value, options = {}) => {
  if (window?.location?.hostname?.includes('localhost')) {
    CookiesProvider.set(key, value, options);
    return () => {
      CookiesProvider.remove(key, { path: options?.path || '/' });
    };
  }
  const setCookie = () => window.ResyUCM?.[`set${consentLevel}Cookie`](key, value, options);
  const isScriptLoaded = `ResyUCM${consentLevel}CookieScript_isLoaded`;
  const scriptLoadedEvent = `ResyUCM${consentLevel}CookieScript_loaded`;

  if (window[isScriptLoaded]) {
    setCookie();
  } else {
    window.addEventListener(scriptLoadedEvent, setCookie);
  }

  // eslint-disable-next-line consistent-return
  return () => window.removeEventListener(scriptLoadedEvent, setCookie);
};

const setEssentialCookie = getCookieSetter(CONSENT_LEVEL.ESSENTIAL);

const useEssentialCookie = ((key, value, options) => {
  useEffect(() => setEssentialCookie(key, value, options), []);
});

const setFunctionalCookie = getCookieSetter(CONSENT_LEVEL.FUNCTIONAL);

const useFunctionalCookie = ((key, value, options) => {
  useEffect(() => setFunctionalCookie(key, value, options), []);
});

const setMarketingCookie = getCookieSetter(CONSENT_LEVEL.MARKETING);

const useMarketingCookie = ((key, value, options) => {
  useEffect(() => setMarketingCookie(key, value, options), []);
});

const setPerformanceCookie = getCookieSetter(CONSENT_LEVEL.PERFORMANCE);

const usePerformanceCookie = ((key, value, options) => {
  useEffect(() => setPerformanceCookie(key, value, options), []);
});

export {
  setEssentialCookie,
  setFunctionalCookie,
  setMarketingCookie,
  setPerformanceCookie,
  useEssentialCookie,
  useFunctionalCookie,
  useMarketingCookie,
  usePerformanceCookie,
};
